module.exports = __webpack_public_path__ + "img/amex@2x.3292b589.png";